import React, { ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import TeaserIcon from '../../Icons/TeaserIcons'
import LiveLabel from '../../Labels/Live'
import Label from '../../Labels/Basic'
import { IconSizeTypes } from '../../Icons/TeaserIcons/IconInterfaces'
import BreakingLabel from '../../Labels/Breaking'
import PearlLabel from '../../Labels/Pearl'
import { TeaserLabelProps } from '../../../Teaser/TeaserInterface'

const getLabel = (labelType?: LabelTypes, labelText?: string): ReactElement | null => {
    if (labelType === 'live') return <LiveLabel />
    if (labelType === 'breaking') return <BreakingLabel />
    if (labelType === 'pearl' && labelText) return <PearlLabel>{labelText}</PearlLabel>
    if (labelText) {
        return <Label>{labelText}</Label>
    }
    return null
}

export type LabelTypes = 'live' | 'onyx' | 'breaking' | 'pearl'

type LabelProps = {
    labels: TeaserLabelProps[]
    margin?: number | number[]
}

export const ImageLabel = ({ labels, margin = 4 }: LabelProps): ReactElement => (
    <Grid zIndex={5} position="absolute" width="100%" height="100%" alignLeft horizontal>
        {labels.map(({ labelType, labelText }, index) => (
            <Grid
                noExpand
                marginTop={margin}
                marginLeft={index === 0 ? margin : 2}
                key={`${labelType}-${labelText}-${index}`}
            >
                {getLabel(labelType, labelText)}
            </Grid>
        ))}
    </Grid>
)

export type IconPositionTypes = 'center' | 'bottom-left'

type ImageIconProps = {
    type: 'gallery-active' | 'video' | 'podcast-active'
    size?: IconSizeTypes | IconSizeTypes[]
    position?: IconPositionTypes
}

const positionProps: Map<IconPositionTypes, object> = new Map([
    ['bottom-left', { alignLeft: true, alignBottom: true }],
    ['center', { center: true }],
])

export const ImageIcon = ({
    type,
    size = 'S',
    position = 'center',
}: ImageIconProps): ReactElement => {
    return (
        <Grid
            zIndex={5}
            position="absolute"
            width="100%"
            height="100%"
            {...positionProps.get(position)}
        >
            <TeaserIcon size={size} icon={type === 'video' ? 'play-active' : type} />
        </Grid>
    )
}
